module.exports = __webpack_public_path__ + "img/icon_search.f37c40e8.svg";